import { createSlice } from "@reduxjs/toolkit";
import {
  addQuestion,
  getOneQuestion,
  getQuestions,
  updateQuestion,
  deleteQuestion,
  toggleQuestionActive,
} from "./thunk";

const initialState = {
  questions: [],
  selectedQuestion: null,
  loading: false,
  error: null,
  totalPages: 1,
  currentPage: 1,
};

const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ===== GET ALL =====
    builder
      .addCase(getQuestions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload.data || [];
        state.totalPages =
          action.payload.responseDetails?.pagination?.totalPages || 1;
        state.currentPage =
          action.payload.responseDetails?.pagination?.currentPage || 1;
      })
      .addCase(getQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // ===== GET ONE =====
    builder.addCase(getOneQuestion.fulfilled, (state, action) => {
      state.selectedQuestion = action.payload;
    });

    // ===== ADD =====
    builder.addCase(addQuestion.fulfilled, (state, action) => {
      state.questions.unshift(action.payload);
    });

    // ===== UPDATE =====
    builder.addCase(updateQuestion.fulfilled, (state, action) => {
      const updatedId = action.payload._id;

      state.questions = state.questions.map((item) =>
        item._id === updatedId ? { ...item, ...action.payload } : item,
      );
    });

    // ===== DELETE =====
    builder.addCase(deleteQuestion.fulfilled, (state, action) => {
      state.questions = state.questions.filter(
        (item) => item._id !== action.payload.id,
      );
    });

    // ===== TOGGLE ACTIVE =====
    builder.addCase(toggleQuestionActive.fulfilled, (state, action) => {
      const id = action.payload;

      state.questions = state.questions.map((question) => {
        if ((question._id || question.id) === id) {
          return {
            ...question,
            isActive: !question.isActive,
          };
        }
        return question;
      });
      // state.questions = state.questions.map((item) =>
      //   item._id === updatedId ? { ...item, ...action.payload } : item,
      // );
    });
  },
});

export default questionSlice.reducer;
